export const TESTS_URL = '/tests';
export const DICTIONARIES_URL = '/dictionaries';
export const GT_IDS_URL = '/gt_ids';
export const SCCP_PROVIDERS_URL = '/sccp_providers';
